<!--
 * @Description: 
 * @Date: 2021-02-05 23:41:06
-->
<template>
  <div>
    <video
      v-if="!showError"
      id="player"
      controls="true"
      playsinline="true"
      webkit-playsinline="true"
      x-webkit-airplay="true"
      x5-playsinline
      v-show="!coverVideo"
      ref="player"
      :poster="livingStore.detail.coverPic"
      :src="livingStore.detail.livingUrl"
    ></video>
    <div class="error" v-else @click="reload">
      <p>播放异常请检查网络后重试</p>
      <p class="reload">点击重载</p>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['livingStore'],
  name: 'LivingPlayer',
  data() {
    return {
      showError: false,
      currentTransIndex: 0, // 当前回放播放下标
      timer: null, // 直播断流或者播放异常，定时重新请求数据
      playTimer: null // 播放后神策上报定时器
    };
  },
  computed: {
    // 回放集合，有多个视频，结束后逐一播放
    transUrls() {
      return (this.livingStore.detail.transUrl || '').split(',');
    },
    livingStatus() {
      return this.livingStore.livingStatus;
    },
    // 优先使用转换地址
    videoUrl() {
      if (this.livingStatus === 5 && this.transUrls.length) {
        return this.transUrls[this.currentTransIndex];
      }
      return this.livingStore.detail.videoUrl;
    },
    // 隐藏视频，防止弹层出现后被视频遮盖
    coverVideo() {
      return this.livingStore.coverVideo;
    }
  },
  methods: {
    play() {
      this.$refs.player && this.$refs.player.play();
    },
    reload() {
      window.location.reload();
    }
  },
  created() {
    // 播放异常事件
    const livingError = () => {
      this.timer && clearInterval(this.timer);
      this.playTimer && clearInterval(this.playTimer);
      if (this.livingStatus === 2) {
        // this.timer = setInterval(async () => {
        //   await this.$store.dispatch(
        //     'living/setCourseDetail',
        //     this.livingStore.detail.id
        //   );
        //   setTimeout(() => {
        //     this.play();
        //   });
        // }, 1000 * 2);
        this.showError = true;
      }
    };
    // 播放结束后连播
    const livingEnd = () => {
      this.playTimer && clearInterval(this.playTimer);
      let transUrlsMaxIndex = this.transUrls.length - 1;
      if (~transUrlsMaxIndex) {
        if (this.currentTransIndex >= transUrlsMaxIndex) {
          this.currentTransIndex = 0;
        } else {
          this.currentTransIndex += 1;
        }
        // setTimeout(() => {
        //   this.play();
        // });
        this.showError = true;
      }
    };
    // 播放开始后上报神策
    const livingPlay = () => {
      if (!this.playTimer) {
        // 先上报一次
        // this.$sa.re_contentview({
        //   type: '直播-看课时长', // 直播，录播，资讯，病例
        //   name: this.livingStore.detail.courseName, // 内容名字
        //   contentid: this.livingStore.detail.id // 内容id
        // });
        // 看课时长上报一分钟一次
        this.playTimer = setInterval(() => {
          this.$sa.re_contentview({
            type: '直播-看课时长', // 直播，录播，资讯，病例
            name: this.livingStore.detail.courseName, // 内容名字
            contentid: this.livingStore.detail.id // 内容id
          });
        }, 1000 * 60);
      }
    };
    const livingPause = () => {
      this.playTimer && clearInterval(this.playTimer);
    };
    let playerListener = () => {
      this.$nextTick(() => {
        this.play();
        try {
          let playerEvent = (event, handle) => {
            this.$refs.player.addEventListener(event, handle, false);
          };
          playerEvent('error', livingError); // 请求数据时遇到错误, 或者断流断流
          playerEvent('ended', livingEnd); // 当前播放完毕监听
          playerEvent('play', livingPlay); // 开始播放
          playerEvent('pause', livingPause); // 停止播放
        } catch (e) {
          console.error('没有直播地址', e);
        }
      });
    };
    // TODO: WeixinJSBridgeReady 不好用了?!
    // document.addEventListener('WeixinJSBridgeReady', playerListener, false);
    playerListener();
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
    this.playTimer && clearInterval(this.playTimer);
  }
};
</script>

<style scoped lang="scss">
#player {
  width: 100vw;
  height: 5.6266rem; // 高度最好用这个，不然个别机型视频会出现显示不全
  object-fit: fill;
}
.error {
  width: 100vw;
  height: 5.6266rem; // 高度最好用这个，不然个别机型视频会出现显示不全
  background: #000;
  padding-top: 2rem;
  p {
    color: #fff;
    text-align: center;
    font-size: 0.32rem;

    &:last-child {
      color: #027cfa;
      font-size: 0.4rem;
      letter-spacing: 0.05rem;
      border: 1px solid #027cfa;
      width: 2.2rem;
      margin: 0 auto;
      padding: 0.05rem;
      margin-top: 0.5rem;
    }
  }
}
</style>
